import { render } from "./PartnerVideo.vue?vue&type=template&id=16776304"
import script from "./PartnerVideo.vue?vue&type=script&lang=js"
export * from "./PartnerVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__